import { RenewalTrigger } from '../domain/token-renewal-facts';
import { AuthProviderType, SigninErrors, SignupErrors } from './auth.state';

export class SetAccessTokenAction {
  static readonly type = '[Auth] SetAccessTokenAction';

  constructor(public token: string) {}
}

export class SignUpEmailPwdAction {
  static readonly type = '[Auth] SignUpEmailPwdAction';

  constructor(
    public email: string,
    public password: string,
    public acceptCgu = false,
    public firstName?: string,
    public lastName?: string,
  ) {}
}

export class SignUpProviderAction {
  static readonly type = '[Auth] SignUpProviderAction';

  constructor(public provider: AuthProviderType) {}
}

export class SignInEmailPwdAction {
  static readonly type = '[Auth] SignIpEmailPwdAction';

  constructor(public email: string, public password: string) {}
}

export class SignInProviderAction {
  static readonly type = '[Auth] SignInProviderAction';

  constructor(public provider: AuthProviderType) {}
}

export class UserSignedAction {
  static readonly type = '[Auth] UserSignedAction';

  /** Post-auth route when no deep-link returnUrl is stored (e.g. /onboarding, /home/explore). */
  constructor(public readonly redirectTo?: string) {}
}

export class SignUpErrorAction {
  static readonly type = '[Auth] SignUpErrorAction';

  constructor(public payload: SignupErrors, public code?: string) {}
}

export class SignInErrorAction {
  static readonly type = '[Auth] SignInErrorAction';

  constructor(public payload: SigninErrors, public code?: string) {}
}

export class SendResetPwdAction {
  static readonly type = '[Auth] SendResetPwdAction';

  constructor(public email: string) {}
}

export class ResetAuthErrorAction {
  static readonly type = '[Auth] ResetAuthErrorAction';
}

export class ResetLoginInProgressAction {
  static readonly type = '[Auth] ResetLoginInProgressAction';
}

export class ResetAllAuthUserAction {
  static readonly type = '[Auth] ResetAllAuthUserAction';
}

export class RefreshTokenAction {
  static readonly type = '[Auth] RefreshTokenAction';

  /**
   * Where the renewal came from, reported when it fails.
   *
   * Defaulted, so the two existing callers keep working and anybody adding a
   * third does not have to think about it. It separates a failure at launch,
   * where Firebase may simply not have restored its user yet, from one hours
   * later, where the session really is gone. See
   * domain/token-renewal-facts.ts and CAPACITOR-D.
   */
  constructor(public readonly trigger: RenewalTrigger = 'request') {}
}
